import React from 'react';

import { Clients } from '@ariksa/notification';
import { ClientsApiEditClientRequest } from '@ariksa/notification/api';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { selectIntegrations } from 'containers/Setup/Integrations/selectors';

import { actions } from '../../../../slice';

import { TeamsForm } from './TeamsForm';

export const EditTeams: React.FC = () => {
  const { activeClient } = useSelector(selectIntegrations);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSubmit = data => {
    const { name, channel_name } = data;

    const payload: ClientsApiEditClientRequest = {
      uuid: activeClient.data?.uuid,
      editClientConfig: {
        name,
        status: true,
        teams: {
          channel_name,
        },
      },
    };

    dispatch(
      actions.updateClientById({
        q: payload,
        onSuccess: () => navigate('/setup/integrations/' + Clients.Teams),
      }),
    );
  };

  return <TeamsForm handleSubmit={handleSubmit} actionType="Update" />;
};
